import * as actionTypes from "../actions/actionTypes";

const initState = {
  postingService: false,
  draftService: null,
  draftServiceId: null,
  darfServiceError: null,
};

const initSendServiceAsDraft = (state, action) => {
  return {
    ...state,
    postingService: action.postingService,
  };
};

const successSendServiceAsDraft = (state, action) => {
  return {
    ...state,
    postingService: action.postingService,
    draftService: action.draftService,
    draftServiceId: action.draftServiceId,
  };
};

const failSendServiceAsDraft = (state, action) => {
  return {
    ...state,
    postingService: action.postingService,
    darfServiceError: action.darfServiceError,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_SEND_SERVICE_AS_DRAFT:
      return initSendServiceAsDraft(state, action);
    case actionTypes.SUCCESS_SEND_SERVICE_AS_DRAFT:
      return successSendServiceAsDraft(state, action);
    case actionTypes.FAIL_SEND_SERVICE_AS_DRAFT:
      return failSendServiceAsDraft(state, action);
    default:
      return state;
  }
};

export default Reducer;
